import { render, staticRenderFns } from "./ColaboradoresView.vue?vue&type=template&id=5f422c5a&scoped=true&"
import script from "./ColaboradoresView.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresView.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradoresView.vue?vue&type=style&index=0&id=5f422c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f422c5a",
  null
  
)

export default component.exports